import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'
const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
          {/* MACHINE LEARNING */}
          <article className="service">
          <div className="service__head">
            <h3>Machine Learning</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon' />
              <p>Tensorflow, PyTorch, HuggingFace Transformers, Scikit-Learn, Numpy, Pandas, and Matplotlib.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Transformers, LLMs, MediaPipe, Linear/Logistic Regression, KNN, SVM, Naive Bayes, K-Means Clustering, Random Forest, ANN.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Data Preprocessing, Predictions, Model Summary, Graphical Outcomes.</p>
            </li>
          </ul>
        </article>
        {/* WEB DEVELOPMENT */}
        <article className="service">
          <div className="service__head">
            <h3>Software Engineering</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon' />
              <p>Linux</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>C++</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Python</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>HTML5</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>CSS3</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>JavaScript</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>React.js</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Django</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>SQL</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Google Cloud Platform (GCP)</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Kubernetes</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Flask</p>
            </li>
          </ul>
        </article>
        {/* FPGA/Embedded */}
        <article className="service">
          <div className="service__head">
            <h3>Embedded Systems</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon' />
              <p>FPGA Programming (Vivado HLS)</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>VHDL</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>ARM Assembly</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services